import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrls: ['./documentation.component.scss']
})
export class DocumentationComponent implements OnInit, OnDestroy {
  public showNewQuoteVideo1 = false;
  public showNewQuoteVideo2 = false;
  public showAutoFillVideo = false;
  public showAssistantVideo = false;
  selectedSection: string = 'quotes';

  public showScrollToTop = false;
  private scrollHandler = this.onWindowScroll.bind(this);

  constructor(private viewportScroller: ViewportScroller) {}

  ngOnInit(): void {
    window.addEventListener('scroll', this.scrollHandler);
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.scrollHandler);
  }

  selectSection(section: string): void {
    this.selectedSection = section;
  }

  scrollToSection(sectionId: string): void {
    this.viewportScroller.scrollToAnchor(sectionId);
  }

  onWindowScroll(): void {
    this.showScrollToTop = window.scrollY > 200;
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
